import styled from "styled-components/macro";

export default styled.div`

@media only screen and (min-width: 480px) {
    .otnotice-content{
        display:flex;
    }
    .otnotice-menu {
        align-self: flex-start;
        position: sticky;
        top: 0px;
        flex: 0 0 310px;
        height: 50vh;
    }
    .otnotice-sections{
        margin-left: 0px;
    }
}
`;